var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amenity"},[_c('vb-icon',{staticClass:"amenity__icon",attrs:{"name":_vm.amenity(_vm.item).icon,"color":_vm.sass('gray-600'),"size":14}}),_c('span',{staticClass:"amenity__text"},[_vm._v(_vm._s(_vm.amenity(_vm.item).label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }